import { checkIsErrorToolOutput } from "@repo/app-types/agents/errorToolOutput";
import type {
  ProposeVoiceAgentInstructionsToolInput,
  ProposeVoiceAgentInstructionsToolOutput,
  TestVoiceAgentInstructionsToolInput,
  TestVoiceAgentInstructionsToolOutput,
} from "@repo/app-types/entities/teammateAgentProposal";
import type { AgentInstructionChecksLlmOutput } from "@repo/app-types/entities/voiceAgentConfigurationTools";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

/** How many of the checks across every section passed. */
function describeChecks(checks: AgentInstructionChecksLlmOutput): string {
  let passed = 0;
  let total = 0;
  for (const section of Object.values(checks)) {
    for (const check of Object.values(section)) {
      total += 1;
      if (check.status === "pass") {
        passed += 1;
      }
    }
  }
  return `${passed} of ${total} checks passed`;
}

export const TestVoiceAgentInstructionsTool: ToolComponent<
  TestVoiceAgentInstructionsToolInput,
  TestVoiceAgentInstructionsToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return "Testing the instructions...";
    }
    if (checkIsErrorToolOutput(props.output)) {
      return "An error occurred while testing the instructions";
    }
    const subject = props.output.candidate_draft
      ? "Tested the draft"
      : "Tested the saved instructions";
    return `${subject} — ${describeChecks(props.output.checks)}`;
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};

export const ProposeVoiceAgentInstructionsTool: ToolComponent<
  ProposeVoiceAgentInstructionsToolInput,
  ProposeVoiceAgentInstructionsToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return "Proposing instruction changes...";
    }
    if (checkIsErrorToolOutput(props.output)) {
      return "An error occurred while proposing instruction changes";
    }
    const count = props.output.proposals.length;
    return `Proposed ${count} ${count === 1 ? "change" : "changes"} — ${describeChecks(props.output.checks)}`;
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
